export const languageswitchActions = {
    changeLanguage
}

function changeLanguage(language){
    return dispatch => {
        dispatch({ type: language });
    }
}